/**
 * What the CSV template editor offers, by the template's purpose (docs/specs/player-import.md PI69, §9). The
 * schedule and results importers read a room's columns in the order it chose, so their editor sets an order. The
 * player import matches headings by name, in any order, and never reads the stored order, so its editor offers
 * none: an up and down control there would set something nothing reads.
 */
export interface CsvEditorRules {
  /** Whether each column carries up and down controls. */
  reorder: boolean;
  /** The line under the template's name. */
  subtitle: string;
  /** The line under "Columns in your file", or none. */
  orderNote: string | null;
  /** The line under "Available columns". */
  availableNote: string;
}

export function csvEditorRules(template: { purpose: string }): CsvEditorRules {
  if (template.purpose === 'import_players') {
    return {
      reorder: false,
      subtitle: "Choose the columns this room's player files carry. They may come in any order; a file needs only the card.",
      orderNote: null,
      // No order to put it at the end of: the import never reads one.
      availableNote: 'Optional columns this template offers.',
    };
  }
  return {
    reorder: true,
    subtitle: 'Choose the columns your file carries and the order they appear in.',
    orderNote: 'Top to bottom is left to right in the file.',
    availableNote: 'Optional columns this template offers. Adding one puts it at the end.',
  };
}
